import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ErrorFallback = ({ resetErrorBoundary, containerName }) => {
  const { t } = useTranslation()

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>{t('common:error_boundary_title')}</h2>
      <p>{t('common:error_boundary_message', { containerName })}</p>
      <button onClick={resetErrorBoundary}>{t('common:error_boundary_retry')}</button>
    </div>
  )
}

ErrorFallback.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
  containerName: PropTypes.string.isRequired,
}

export default ErrorFallback
